
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

    report_billing
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,


            loading: false,
            data: [],
            data_search: ""
        }
        this.tableRef = React.createRef();
    }
    async componentDidMount() {
        this.Get();
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: this.state.data_search,
            bill_id: ""
        }
        let result = await GET(tokens, "v1/TH/quotation/bill/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>รายงานใบวางบิล</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-orange mx-1" onClick={() => { report_billing(this.state.data) }}>
                                    พิมพ์รายงาน
                                </button>
                                <DownloadTableExcel
                                    filename="รายงานใบวางบิล"
                                    sheet="รายงานใบวางบิล"
                                    currentTableRef={this.tableRef.current}
                                >
                                    <button type="button" className="btn btn-dark px-4 mx-1 mb-2">
                                        EXCEL
                                    </button>
                                </DownloadTableExcel>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" ref={this.tableRef}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">วันที่</th>
                                            <th className="text-center text-white">เลขที่เอกสาร</th>
                                            <th className="text-left text-white">ชื่อลูกค้า</th>
                                            <th className="text-end text-white">ยอดรวมสุทธิ</th>
                                            <th className="text-center text-white">สถานะ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm") : "-"}</td>
                                                <td className="text-center">{item.bill_number ? item.bill_number : "-"}</td>
                                                <td className="text-left">{item.full_name ? item.full_name : "-"}</td>
                                                <td className="text-end">{item.net_total_amount ? toFixed(item.net_total_amount) : "-"}</td>
                                                <td className="text-center">{item.bill_status === 1 ? "รออนุมัติ" : "อนุมัติ"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
